import React, { ReactNode, CSSProperties } from "react";
import classes from "./Button.module.scss";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Spinner, { ESpinnerColor, ESpinnerSize } from "../Spinner/Spinner";

export enum EButtonSize {
  X_SMALL,
  SMALL,
  MEDIUM,
  LARGE,
}

export enum EButtonColor {
  PRIMARY,
  DEFAULT,
  SECONDARY,
  SUCCESS,
  DANGER,
  WARNING,
  WARNING_SECONDARY,
}

export interface IButtonProps {
  icon?: IconDefinition;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
  size?: EButtonSize;
  color?: EButtonColor;
  loading?: boolean;
  type?: "submit" | "reset" | "button";
  buttonRef?: React.RefObject<HTMLButtonElement>;
  outlined?: boolean;
}

const Button: React.FC<IButtonProps> = ({
  icon,
  onClick,
  disabled,
  children,
  className,
  style,
  size,
  color,
  loading,
  type = "button",
  buttonRef,
  outlined,
}) => {
  const classNames = [classes.Button];
  
  if (className) {
    classNames.push(className);
  }

  if (outlined) {
    classNames.push(classes.Outlined);
  }

  switch (size) {
    case EButtonSize.X_SMALL:
      classNames.push(classes.XSmall);
      break;
    case EButtonSize.SMALL:
      classNames.push(classes.Small);
      break;
    case EButtonSize.LARGE:
      classNames.push(classes.Large);
      break;
    default:
  }

  switch (color) {
    case EButtonColor.DEFAULT:
      classNames.push(classes.Default);
      break;
    case EButtonColor.SECONDARY:
      classNames.push(classes.Secondary);
      break;
    case EButtonColor.SUCCESS:
      classNames.push(classes.Success);
      break;
    case EButtonColor.DANGER:
      classNames.push(classes.Danger);
      break;
    case EButtonColor.WARNING:
      classNames.push(classes.Warning);
      break;
    case EButtonColor.WARNING_SECONDARY:
      classNames.push(classes.WarningSecondary);
      break;
    default:
  }

  return (
    <button
      className={classNames.join(" ")}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      style={style}
      ref={buttonRef}
    >
      {loading ? (
        <Spinner size={ESpinnerSize.SMALL} color={ESpinnerColor.CONTENT} />
      ) : (
        <>
          {icon && <FontAwesomeIcon icon={icon} />} {children}
        </>
      )}
    </button>
  );
};

export default Button;
